import { zhCN_menu } from './menu'
import { zhCN_system } from './sys'

const zh_CN = {
	...zhCN_menu,
	...zhCN_system
}

export default zh_CN
